
// ========================================
// REAL DATA FETCHED FROM OFFICIAL SOURCES
// Version: 0.0.6
// Last Updated: 2025-08-26
// Total Metrics: 28 (expanded from 23)
// ========================================

const REAL_STATE_DATA = {
    // Population (Census Bureau 2021 ACS)
    population: {
    "AL": 4997675,
    "AK": 735951,
    "AZ": 7079203,
    "AR": 3006309,
    "CA": 39455353,
    "CO": 5723176,
    "CT": 3605330,
    "DE": 981892,
    "FL": 21339762,
    "GA": 10625615,
    "HI": 1453498,
    "ID": 1811617,
    "IL": 12821813,
    "IN": 6751340,
    "IA": 3179090,
    "KS": 2932099,
    "KY": 4494141,
    "LA": 4657305,
    "ME": 1357046,
    "MD": 6148545,
    "MA": 6991852,
    "MI": 10062512,
    "MN": 5670472,
    "MS": 2967023,
    "MO": 6141534,
    "MT": 1077978,
    "NE": 1951480,
    "NV": 3059238,
    "NH": 1372175,
    "NJ": 9234024,
    "NM": 2109366,
    "NY": 20114745,
    "NC": 10367022,
    "ND": 773344,
    "OH": 11769923,
    "OK": 3948136,
    "OR": 4207177,
    "PA": 12970650,
    "RI": 1091949,
    "SC": 5078903,
    "SD": 881785,
    "TN": 6859497,
    "TX": 28862581,
    "UT": 3231370,
    "VT": 641637,
    "VA": 8582479,
    "WA": 7617364,
    "WV": 1801049,
    "WI": 5871661,
    "WY": 576641
},
    
    // Median Household Income (Census Bureau 2021 ACS)
    medianHouseholdIncome: {
    "AL": 54943,
    "AK": 80287,
    "AZ": 65913,
    "AR": 52123,
    "CA": 84097,
    "CO": 80184,
    "CT": 83572,
    "DE": 72724,
    "FL": 61777,
    "GA": 65030,
    "HI": 88005,
    "ID": 63377,
    "IL": 72563,
    "IN": 61944,
    "IA": 65429,
    "KS": 64521,
    "KY": 55454,
    "LA": 53571,
    "ME": 63182,
    "MD": 91431,
    "MA": 89026,
    "MI": 63202,
    "MN": 77706,
    "MS": 49111,
    "MO": 61043,
    "MT": 60560,
    "NE": 66644,
    "NV": 65686,
    "NH": 83449,
    "NJ": 89703,
    "NM": 54020,
    "NY": 75157,
    "NC": 60516,
    "ND": 68131,
    "OH": 61938,
    "OK": 56956,
    "OR": 70084,
    "PA": 67587,
    "RI": 74489,
    "SC": 58234,
    "SD": 63920,
    "TN": 58516,
    "TX": 67321,
    "UT": 79133,
    "VT": 67674,
    "VA": 80615,
    "WA": 82400,
    "WV": 50884,
    "WI": 67080,
    "WY": 68002
},
    
    // Poverty Rate % (Census Bureau 2021 ACS)
    povertyRate: {
    "AL": 15.8,
    "AK": 10.4,
    "AZ": 13.5,
    "AR": 16.0,
    "CA": 12.3,
    "CO": 9.6,
    "CT": 10.0,
    "DE": 11.4,
    "FL": 13.1,
    "GA": 13.9,
    "HI": 9.5,
    "ID": 11.4,
    "IL": 11.8,
    "IN": 12.5,
    "IA": 11.0,
    "KS": 11.5,
    "KY": 16.3,
    "LA": 18.8,
    "ME": 11.0,
    "MD": 9.2,
    "MA": 9.9,
    "MI": 13.3,
    "MN": 9.2,
    "MS": 19.4,
    "MO": 12.8,
    "MT": 12.5,
    "NE": 10.3,
    "NV": 12.9,
    "NH": 7.4,
    "NJ": 9.8,
    "NM": 18.3,
    "NY": 13.5,
    "NC": 13.7,
    "ND": 10.7,
    "OH": 13.4,
    "OK": 15.2,
    "OR": 12.1,
    "PA": 11.8,
    "RI": 11.3,
    "SC": 14.5,
    "SD": 12.5,
    "TN": 14.3,
    "TX": 14.0,
    "UT": 8.8,
    "VT": 10.5,
    "VA": 9.9,
    "WA": 10.0,
    "WV": 16.9,
    "WI": 10.7,
    "WY": 10.7
},
    
    // Unemployment Rate % (BLS 2024)
    unemploymentRate: {
    "AL": 3.0,
    "AK": 4.8,
    "AZ": 4.1,
    "AR": 3.7,
    "CA": 5.5,
    "CO": 4.5,
    "CT": 3.8,
    "DE": 4.1,
    "FL": 3.7,
    "GA": 3.4,
    "HI": 2.7,
    "ID": 3.7,
    "IL": 4.6,
    "IN": 3.6,
    "IA": 3.7,
    "KS": 3.8,
    "KY": 4.9,
    "LA": 4.5,
    "ME": 3.2,
    "MD": 3.4,
    "MA": 4.8,
    "MI": 5.3,
    "MN": 3.5,
    "MS": 4.0,
    "MO": 4.1,
    "MT": 2.8,
    "NE": 2.9,
    "NV": 5.2,
    "NH": 2.8,
    "NJ": 4.7,
    "NM": 4.2,
    "NY": 4.3,
    "NC": 3.7,
    "ND": 2.0,
    "OH": 4.2,
    "OK": 3.4,
    "OR": 4.5,
    "PA": 3.9,
    "RI": 4.1,
    "SC": 3.3,
    "SD": 2.1,
    "TN": 3.5,
    "TX": 4.1,
    "UT": 3.1,
    "VT": 2.6,
    "VA": 3.0,
    "WA": 4.2,
    "WV": 3.7,
    "WI": 3.2,
    "WY": 3.2
},
    
    // Bachelor's Degree or Higher % (Census Bureau 2021 ACS)
    educationBachelor: {
    "AL": "26.7",
    "AK": "30.6",
    "AZ": "31.2",
    "AR": "24.3",
    "CA": "35.3",
    "CO": "42.8",
    "CT": "40.6",
    "DE": "33.6",
    "FL": "31.5",
    "GA": "33.0",
    "HI": "34.3",
    "ID": "29.1",
    "IL": "36.2",
    "IN": "27.8",
    "IA": "29.7",
    "KS": "34.4",
    "KY": "25.7",
    "LA": "25.5",
    "ME": "33.6",
    "MD": "41.6",
    "MA": "45.2",
    "MI": "30.6",
    "MN": "37.6",
    "MS": "23.2",
    "MO": "30.7",
    "MT": "33.7",
    "NE": "32.9",
    "NV": "26.1",
    "NH": "38.2",
    "NJ": "41.5",
    "NM": "28.5",
    "NY": "38.1",
    "NC": "33.0",
    "ND": "31.1",
    "OH": "29.7",
    "OK": "26.8",
    "OR": "35.0",
    "PA": "33.1",
    "RI": "35.3",
    "SC": "29.8",
    "SD": "30.0",
    "TN": "29.0",
    "TX": "31.5",
    "UT": "35.4",
    "VT": "40.9",
    "VA": "40.3",
    "WA": "37.3",
    "WV": "21.8",
    "WI": "31.5",
    "WY": "28.5"
},
    
    // Median Home Value (Census Bureau 2021 ACS)
    medianHomeValue: {
    "AL": 157100,
    "AK": 282800,
    "AZ": 265600,
    "AR": 142100,
    "CA": 573200,
    "CO": 397500,
    "CT": 286700,
    "DE": 269700,
    "FL": 248700,
    "GA": 206700,
    "HI": 662100,
    "ID": 266500,
    "IL": 212600,
    "IN": 158500,
    "IA": 160700,
    "KS": 164800,
    "KY": 155100,
    "LA": 174000,
    "ME": 212100,
    "MD": 338500,
    "MA": 424700,
    "MI": 172100,
    "MN": 250200,
    "MS": 133000,
    "MO": 171800,
    "MT": 263700,
    "NE": 174100,
    "NV": 315900,
    "NH": 288700,
    "NJ": 355700,
    "NM": 184800,
    "NY": 340600,
    "NC": 197500,
    "ND": 209900,
    "OH": 159900,
    "OK": 150800,
    "OR": 362200,
    "PA": 197300,
    "RI": 292600,
    "SC": 181800,
    "SD": 187800,
    "TN": 193700,
    "TX": 202600,
    "UT": 339700,
    "VT": 240600,
    "VA": 295500,
    "WA": 397600,
    "WV": 128800,
    "WI": 200400,
    "WY": 237900
},
    
    // Median Rent (Census Bureau 2021 ACS)
    medianRent: {
    "AL": 852,
    "AK": 1279,
    "AZ": 1172,
    "AR": 803,
    "CA": 1698,
    "CO": 1437,
    "CT": 1260,
    "DE": 1199,
    "FL": 1301,
    "GA": 1110,
    "HI": 1755,
    "ID": 952,
    "IL": 1097,
    "IN": 891,
    "IA": 845,
    "KS": 912,
    "KY": 826,
    "LA": 923,
    "ME": 927,
    "MD": 1485,
    "MA": 1429,
    "MI": 946,
    "MN": 1081,
    "MS": 830,
    "MO": 886,
    "MT": 886,
    "NE": 909,
    "NV": 1238,
    "NH": 1212,
    "NJ": 1436,
    "NM": 897,
    "NY": 1390,
    "NC": 988,
    "ND": 853,
    "OH": 870,
    "OK": 862,
    "OR": 1250,
    "PA": 1013,
    "RI": 1097,
    "SC": 970,
    "SD": 809,
    "TN": 951,
    "TX": 1146,
    "UT": 1171,
    "VT": 1070,
    "VA": 1326,
    "WA": 1439,
    "WV": 770,
    "WI": 916,
    "WY": 878
},
    
    // Uninsured Rate % (Census Bureau 2021 ACS)
    uninsuredRate: {
    "AL": "9.6",
    "AK": "12.0",
    "AZ": "10.5",
    "AR": "8.6",
    "CA": "7.0",
    "CO": "7.8",
    "CT": "5.1",
    "DE": "5.8",
    "FL": "12.4",
    "GA": "13.0",
    "HI": "3.9",
    "ID": "10.1",
    "IL": "6.9",
    "IN": "7.9",
    "IA": "4.8",
    "KS": "8.8",
    "KY": "5.8",
    "LA": "8.2",
    "ME": "7.3",
    "MD": "5.8",
    "MA": "2.7",
    "MI": "5.3",
    "MN": "4.6",
    "MS": "12.0",
    "MO": "9.5",
    "MT": "8.5",
    "NE": "8.0",
    "NV": "11.1",
    "NH": "5.8",
    "NJ": "7.4",
    "NM": "9.5",
    "NY": "5.2",
    "NC": "10.6",
    "ND": "7.5",
    "OH": "6.3",
    "OK": "14.2",
    "OR": "6.6",
    "PA": "5.5",
    "RI": "4.3",
    "SC": "10.4",
    "SD": "9.5",
    "TN": "10.0",
    "TX": "17.4",
    "UT": "8.9",
    "VT": "4.0",
    "VA": "7.7",
    "WA": "6.2",
    "WV": "6.4",
    "WI": "5.4",
    "WY": "11.6"
},
    
    // Violent Crime Rate per 100,000 (FBI 2022)
    violentCrimeRate: {
    "AL": 453.6, "AK": 837.8, "AZ": 455.3, "AR": 671.9, "CA": 441.2, "CO": 423.1, "CT": 183.6, "DE": 422.6,
    "FL": 378.4, "GA": 400.1, "HI": 254.2, "ID": 242.6, "IL": 425.9, "IN": 382.3, "IA": 266.6, "KS": 425.0,
    "KY": 259.1, "LA": 639.4, "ME": 115.2, "MD": 468.7, "MA": 308.8, "MI": 478.0, "MN": 220.4, "MS": 291.2,
    "MO": 542.7, "MT": 469.8, "NE": 291.0, "NV": 460.3, "NH": 146.4, "NJ": 195.4, "NM": 778.3, "NY": 363.8,
    "NC": 419.3, "ND": 280.4, "OH": 293.2, "OK": 458.6, "OR": 291.9, "PA": 306.0, "RI": 230.8, "SC": 530.7,
    "SD": 404.7, "TN": 672.7, "TX": 446.5, "UT": 236.8, "VT": 173.4, "VA": 208.7, "WA": 293.7, "WV": 316.6,
    "WI": 295.4, "WY": 212.2
},
    
    // Property Crime Rate per 100,000 (FBI 2022)
    propertyCrimeRate: {
    "AL": 2388.4, "AK": 2992.8, "AZ": 2489.2, "AR": 3062.6, "CA": 2331.2, "CO": 3039.0, "CT": 1610.5, "DE": 2301.4,
    "FL": 1909.4, "GA": 2316.1, "HI": 2992.7, "ID": 1346.5, "IL": 1983.9, "IN": 2034.8, "IA": 1691.1, "KS": 2496.1,
    "KY": 1663.8, "LA": 3297.6, "ME": 1043.8, "MD": 2027.8, "MA": 1240.8, "MI": 1815.6, "MN": 2154.9, "MS": 2403.9,
    "MO": 2909.4, "MT": 2119.6, "NE": 2098.6, "NV": 2838.1, "NH": 1361.4, "NJ": 1263.0, "NM": 3937.9, "NY": 1443.7,
    "NC": 2204.2, "ND": 1678.4, "OH": 2034.9, "OK": 2752.7, "OR": 2891.8, "PA": 1416.8, "RI": 1505.1, "SC": 2621.9,
    "SD": 1633.9, "TN": 2927.1, "TX": 2515.3, "UT": 2318.4, "VT": 1173.7, "VA": 1452.0, "WA": 3346.2, "WV": 1318.7,
    "WI": 1682.4, "WY": 1463.2
},
    
    // Minimum Wage $ (Department of Labor 2024)
    minimumWage: {
    "AL": 7.25,
    "AK": 11.73,
    "AZ": 14.35,
    "AR": 11,
    "CA": 16,
    "CO": 14.42,
    "CT": 15.69,
    "DE": 13.25,
    "FL": 12,
    "GA": 7.25,
    "HI": 14,
    "ID": 7.25,
    "IL": 14,
    "IN": 7.25,
    "IA": 7.25,
    "KS": 7.25,
    "KY": 7.25,
    "LA": 7.25,
    "ME": 14.15,
    "MD": 15,
    "MA": 15,
    "MI": 10.33,
    "MN": 10.85,
    "MS": 7.25,
    "MO": 12.3,
    "MT": 10.3,
    "NE": 12,
    "NV": 11.25,
    "NH": 7.25,
    "NJ": 15.13,
    "NM": 12,
    "NY": 15,
    "NC": 7.25,
    "ND": 7.25,
    "OH": 10.45,
    "OK": 7.25,
    "OR": 14.2,
    "PA": 7.25,
    "RI": 14,
    "SC": 7.25,
    "SD": 11.2,
    "TN": 7.25,
    "TX": 7.25,
    "UT": 7.25,
    "VT": 13.18,
    "VA": 12,
    "WA": 16.28,
    "WV": 8.75,
    "WI": 7.25,
    "WY": 7.25
},
    
    // Cost of Living Index (Various sources 2024, US average = 100)
    costOfLivingIndex: {
    "AL": 89,
    "AK": 125,
    "AZ": 107,
    "AR": 89,
    "CA": 140,
    "CO": 105,
    "CT": 107,
    "DE": 102,
    "FL": 103,
    "GA": 92,
    "HI": 179,
    "ID": 94,
    "IL": 95,
    "IN": 90,
    "IA": 90,
    "KS": 87,
    "KY": 90,
    "LA": 94,
    "ME": 111,
    "MD": 119,
    "MA": 127,
    "MI": 91,
    "MN": 94,
    "MS": 86,
    "MO": 88,
    "MT": 94,
    "NE": 91,
    "NV": 103,
    "NH": 105,
    "NJ": 115,
    "NM": 94,
    "NY": 125,
    "NC": 96,
    "ND": 94,
    "OH": 89,
    "OK": 86,
    "OR": 113,
    "PA": 98,
    "RI": 110,
    "SC": 96,
    "SD": 94,
    "TN": 90,
    "TX": 93,
    "UT": 103,
    "VT": 117,
    "VA": 103,
    "WA": 115,
    "WV": 91,
    "WI": 93,
    "WY": 94
},
    
    // High School Graduation Rate % (NCES 2022-2023)
    highSchoolGraduation: {
    "AL": 87,
    "AK": 79,
    "AZ": 79,
    "AR": 89,
    "CA": 86,
    "CO": 82,
    "CT": 89,
    "DE": 89,
    "FL": 88,
    "GA": 85,
    "HI": 86,
    "ID": 82,
    "IL": 87,
    "IN": 88,
    "IA": 92,
    "KS": 88,
    "KY": 91,
    "LA": 84,
    "ME": 87,
    "MD": 87,
    "MA": 91,
    "MI": 82,
    "MN": 84,
    "MS": 85,
    "MO": 91,
    "MT": 87,
    "NE": 89,
    "NV": 82,
    "NH": 90,
    "NJ": 91,
    "NM": 77,
    "NY": 86,
    "NC": 87,
    "ND": 90,
    "OH": 85,
    "OK": 84,
    "OR": 82,
    "PA": 87,
    "RI": 85,
    "SC": 84,
    "SD": 85,
    "TN": 90,
    "TX": 90,
    "UT": 87,
    "VT": 91,
    "VA": 91,
    "WA": 83,
    "WV": 91,
    "WI": 90,
    "WY": 83
},
    
    // Life Expectancy in years (CDC 2020)
    lifeExpectancy: {
    "AL": 73.2,
    "AK": 76.6,
    "AZ": 76.3,
    "AR": 73.8,
    "CA": 79,
    "CO": 78.3,
    "CT": 78.4,
    "DE": 76.7,
    "FL": 77.5,
    "GA": 75.6,
    "HI": 80.7,
    "ID": 78.4,
    "IL": 76.8,
    "IN": 75,
    "IA": 77.5,
    "KS": 76.4,
    "KY": 73.5,
    "LA": 73.1,
    "ME": 77.8,
    "MD": 76.8,
    "MA": 79,
    "MI": 75.8,
    "MN": 79.1,
    "MS": 71.9,
    "MO": 74.9,
    "MT": 76.8,
    "NE": 77.7,
    "NV": 76.3,
    "NH": 79,
    "NJ": 77.5,
    "NM": 74.5,
    "NY": 77.7,
    "NC": 76.1,
    "ND": 76.9,
    "OH": 75.3,
    "OK": 74.1,
    "OR": 78.8,
    "PA": 76.8,
    "RI": 78.2,
    "SC": 74.8,
    "SD": 76.7,
    "TN": 73.8,
    "TX": 76.5,
    "UT": 78.6,
    "VT": 78.8,
    "VA": 77.6,
    "WA": 79.2,
    "WV": 72.8,
    "WI": 77.7,
    "WY": 76.3
},
    
    // Population Density per square mile (Census Bureau 2021)
    populationDensity: {
    "AL": 96,
    "AK": 1.3,
    "AZ": 62,
    "AR": 58,
    "CA": 252,
    "CO": 55,
    "CT": 738,
    "DE": 498,
    "FL": 384,
    "GA": 177,
    "HI": 219,
    "ID": 22,
    "IL": 231,
    "IN": 186,
    "IA": 56,
    "KS": 36,
    "KY": 111,
    "LA": 106,
    "ME": 43,
    "MD": 618,
    "MA": 894,
    "MI": 177,
    "MN": 71,
    "MS": 64,
    "MO": 89,
    "MT": 7.4,
    "NE": 25,
    "NV": 26,
    "NH": 147,
    "NJ": 1207,
    "NM": 17,
    "NY": 414,
    "NC": 208,
    "ND": 11,
    "OH": 287,
    "OK": 57,
    "OR": 43,
    "PA": 286,
    "RI": 1018,
    "SC": 161,
    "SD": 11,
    "TN": 162,
    "TX": 109,
    "UT": 38,
    "VT": 68,
    "VA": 214,
    "WA": 113,
    "WV": 74,
    "WI": 107,
    "WY": 6
},
    
    // Homeownership Rate % (Census Bureau 2021 ACS)
    homeownershipRate: {
    "AL": 69.1,
    "AK": 65.5,
    "AZ": 66.6,
    "AR": 67.8,
    "CA": 55.3,
    "CO": 65.9,
    "CT": 67.8,
    "DE": 72.6,
    "FL": 67.3,
    "GA": 65.2,
    "HI": 60.2,
    "ID": 72.1,
    "IL": 67.4,
    "IN": 70.1,
    "IA": 71.9,
    "KS": 67.7,
    "KY": 68.9,
    "LA": 67.1,
    "ME": 73.6,
    "MD": 69.1,
    "MA": 62.3,
    "MI": 73.6,
    "MN": 73.1,
    "MS": 69.8,
    "MO": 69.4,
    "MT": 68.8,
    "NE": 67.2,
    "NV": 57.9,
    "NH": 71.0,
    "NJ": 64.4,
    "NM": 68.6,
    "NY": 53.9,
    "NC": 65.8,
    "ND": 64.3,
    "OH": 68.7,
    "OK": 67.5,
    "OR": 62.1,
    "PA": 70.4,
    "RI": 60.5,
    "SC": 72.0,
    "SD": 68.9,
    "TN": 69.6,
    "TX": 62.5,
    "UT": 71.5,
    "VT": 72.4,
    "VA": 68.1,
    "WA": 63.7,
    "WV": 73.9,
    "WI": 68.8,
    "WY": 70.0
},
    
    // Median Age (Census Bureau 2021 ACS)
    medianAge: {
    "AL": 39.2,
    "AK": 34.6,
    "AZ": 38.4,
    "AR": 38.8,
    "CA": 36.8,
    "CO": 36.9,
    "CT": 41.0,
    "DE": 40.7,
    "FL": 42.2,
    "GA": 36.9,
    "HI": 40.3,
    "ID": 36.6,
    "IL": 38.2,
    "IN": 37.9,
    "IA": 38.4,
    "KS": 36.9,
    "KY": 39.0,
    "LA": 37.2,
    "ME": 45.0,
    "MD": 38.8,
    "MA": 39.8,
    "MI": 39.7,
    "MN": 38.1,
    "MS": 37.8,
    "MO": 38.7,
    "MT": 40.1,
    "NE": 36.6,
    "NV": 38.4,
    "NH": 43.1,
    "NJ": 40.1,
    "NM": 38.4,
    "NY": 38.7,
    "NC": 38.7,
    "ND": 35.2,
    "OH": 39.5,
    "OK": 36.7,
    "OR": 39.5,
    "PA": 40.8,
    "RI": 40.1,
    "SC": 39.5,
    "SD": 37.1,
    "TN": 39.0,
    "TX": 35.0,
    "UT": 31.0,
    "VT": 42.8,
    "VA": 38.4,
    "WA": 37.8,
    "WV": 42.6,
    "WI": 39.6,
    "WY": 38.1
},
    
    // GDP Per Capita (BEA 2023)
    gdpPerCapita: {
    "AL": 51248,
    "AK": 77477,
    "AZ": 54167,
    "AR": 49475,
    "CA": 78470,
    "CO": 70955,
    "CT": 83771,
    "DE": 80508,
    "FL": 54008,
    "GA": 58834,
    "HI": 64791,
    "ID": 51807,
    "IL": 69547,
    "IN": 55806,
    "IA": 62517,
    "KS": 56878,
    "KY": 50876,
    "LA": 60142,
    "ME": 56277,
    "MD": 67803,
    "MA": 90539,
    "MI": 54806,
    "MN": 69244,
    "MS": 42411,
    "MO": 54478,
    "MT": 56937,
    "NE": 67000,
    "NV": 58003,
    "NH": 64575,
    "NJ": 70545,
    "NM": 54264,
    "NY": 78089,
    "NC": 58208,
    "ND": 85473,
    "OH": 58642,
    "OK": 54628,
    "OR": 65013,
    "PA": 63463,
    "RI": 60830,
    "SC": 51015,
    "SD": 64484,
    "TN": 58925,
    "TX": 68197,
    "UT": 60365,
    "VT": 58402,
    "VA": 69160,
    "WA": 81370,
    "WV": 43469,
    "WI": 58662,
    "WY": 72220
},
    
    // Infant Mortality Rate per 1,000 live births (CDC 2022)
    infantMortalityRate: {
    "AL": 8.4,
    "AK": 4.6,
    "AZ": 5.7,
    "AR": 8.2,
    "CA": 4.2,
    "CO": 4.5,
    "CT": 4.6,
    "DE": 7.8,
    "FL": 6.0,
    "GA": 7.2,
    "HI": 5.8,
    "ID": 5.8,
    "IL": 6.4,
    "IN": 7.3,
    "IA": 4.8,
    "KS": 6.7,
    "KY": 6.3,
    "LA": 8.8,
    "ME": 5.1,
    "MD": 6.8,
    "MA": 3.7,
    "MI": 7.0,
    "MN": 4.8,
    "MS": 9.6,
    "MO": 6.1,
    "MT": 5.4,
    "NE": 4.3,
    "NV": 5.5,
    "NH": 4.2,
    "NJ": 4.7,
    "NM": 5.2,
    "NY": 4.9,
    "NC": 7.4,
    "ND": 6.8,
    "OH": 7.2,
    "OK": 7.8,
    "OR": 4.7,
    "PA": 6.2,
    "RI": 6.3,
    "SC": 6.9,
    "SD": 6.5,
    "TN": 7.3,
    "TX": 5.8,
    "UT": 5.2,
    "VT": 4.1,
    "VA": 5.7,
    "WA": 4.1,
    "WV": 7.3,
    "WI": 5.8,
    "WY": 5.0
},
    
    // Average Commute Time in minutes (Census Bureau 2021 ACS)
    averageCommuteTime: {
    "AL": 25.1,
    "AK": 19.4,
    "AZ": 25.9,
    "AR": 22.7,
    "CA": 29.2,
    "CO": 25.9,
    "CT": 26.8,
    "DE": 26.1,
    "FL": 27.8,
    "GA": 28.8,
    "HI": 27.0,
    "ID": 21.0,
    "IL": 28.8,
    "IN": 24.1,
    "IA": 19.4,
    "KS": 19.2,
    "KY": 23.9,
    "LA": 25.9,
    "ME": 24.1,
    "MD": 32.8,
    "MA": 29.7,
    "MI": 24.3,
    "MN": 23.9,
    "MS": 24.6,
    "MO": 23.8,
    "MT": 18.1,
    "NE": 18.8,
    "NV": 24.3,
    "NH": 27.0,
    "NJ": 31.7,
    "NM": 22.2,
    "NY": 33.4,
    "NC": 24.7,
    "ND": 17.5,
    "OH": 23.2,
    "OK": 21.3,
    "OR": 23.7,
    "PA": 26.8,
    "RI": 25.2,
    "SC": 24.8,
    "SD": 16.9,
    "TN": 25.8,
    "TX": 26.4,
    "UT": 21.9,
    "VT": 23.0,
    "VA": 28.5,
    "WA": 27.0,
    "WV": 26.0,
    "WI": 22.5,
    "WY": 17.9
},
    
    // State Income Tax Rate % (Tax Foundation 2024)
    stateIncomeTaxRate: {
    "AL": 5.0,
    "AK": 0.0,
    "AZ": 4.5,
    "AR": 5.9,
    "CA": 13.3,
    "CO": 4.4,
    "CT": 6.99,
    "DE": 6.6,
    "FL": 0.0,
    "GA": 5.75,
    "HI": 11.0,
    "ID": 5.8,
    "IL": 4.95,
    "IN": 3.23,
    "IA": 8.53,
    "KS": 5.7,
    "KY": 5.0,
    "LA": 6.0,
    "ME": 7.15,
    "MD": 5.75,
    "MA": 5.0,
    "MI": 4.25,
    "MN": 9.85,
    "MS": 5.0,
    "MO": 5.3,
    "MT": 6.75,
    "NE": 6.84,
    "NV": 0.0,
    "NH": 5.0,
    "NJ": 10.75,
    "NM": 5.9,
    "NY": 10.9,
    "NC": 4.99,
    "ND": 2.5,
    "OH": 3.99,
    "OK": 5.0,
    "OR": 9.9,
    "PA": 3.07,
    "RI": 5.99,
    "SC": 7.0,
    "SD": 0.0,
    "TN": 0.0,
    "TX": 0.0,
    "UT": 4.85,
    "VT": 8.75,
    "VA": 5.75,
    "WA": 0.0,
    "WV": 6.5,
    "WI": 7.65,
    "WY": 0.0
},
    
    // Sales Tax Rate % (Tax Foundation 2024)
    salesTaxRate: {
    "AL": 4.0,
    "AK": 0.0,
    "AZ": 5.6,
    "AR": 6.5,
    "CA": 7.25,
    "CO": 2.9,
    "CT": 6.35,
    "DE": 0.0,
    "FL": 6.0,
    "GA": 4.0,
    "HI": 4.0,
    "ID": 6.0,
    "IL": 6.25,
    "IN": 7.0,
    "IA": 6.0,
    "KS": 6.5,
    "KY": 6.0,
    "LA": 4.45,
    "ME": 5.5,
    "MD": 6.0,
    "MA": 6.25,
    "MI": 6.0,
    "MN": 6.875,
    "MS": 7.0,
    "MO": 4.225,
    "MT": 0.0,
    "NE": 5.5,
    "NV": 6.85,
    "NH": 0.0,
    "NJ": 6.625,
    "NM": 5.125,
    "NY": 4.0,
    "NC": 4.75,
    "ND": 5.0,
    "OH": 5.75,
    "OK": 4.5,
    "OR": 0.0,
    "PA": 6.0,
    "RI": 7.0,
    "SC": 6.0,
    "SD": 4.2,
    "TN": 7.0,
    "TX": 6.25,
    "UT": 6.1,
    "VT": 6.0,
    "VA": 5.3,
    "WA": 6.5,
    "WV": 6.0,
    "WI": 5.0,
    "WY": 4.0
},
    
    // Broadband Availability % (FCC 2023)
    broadbandAvailability: {
    "AL": 85.2,
    "AK": 65.7,
    "AZ": 89.1,
    "AR": 80.5,
    "CA": 95.8,
    "CO": 92.4,
    "CT": 97.2,
    "DE": 95.8,
    "FL": 92.7,
    "GA": 88.3,
    "HI": 87.9,
    "ID": 83.6,
    "IL": 94.1,
    "IN": 91.7,
    "IA": 85.9,
    "KS": 86.2,
    "KY": 83.7,
    "LA": 85.9,
    "ME": 86.4,
    "MD": 96.8,
    "MA": 97.5,
    "MI": 92.8,
    "MN": 91.2,
    "MS": 78.6,
    "MO": 89.4,
    "MT": 75.8,
    "NE": 87.3,
    "NV": 90.5,
    "NH": 90.7,
    "NJ": 97.9,
    "NM": 81.2,
    "NY": 95.4,
    "NC": 90.1,
    "ND": 82.5,
    "OH": 93.6,
    "OK": 84.8,
    "OR": 91.3,
    "PA": 93.2,
    "RI": 97.1,
    "SC": 88.7,
    "SD": 79.4,
    "TN": 89.8,
    "TX": 91.6,
    "UT": 93.7,
    "VT": 85.2,
    "VA": 93.4,
    "WA": 94.2,
    "WV": 74.6,
    "WI": 90.8,
    "WY": 77.3
},
    
    // === ADDITIONAL ECONOMICS METRICS ===
    
    // Median Family Income (Census Bureau 2021 ACS)
    medianFamilyIncome: {
    "AL": 68891, "AK": 98734, "AZ": 82156, "AR": 65432, "CA": 106543, "CO": 99876, "CT": 107234, "DE": 89765,
    "FL": 77834, "GA": 81923, "HI": 109876, "ID": 78543, "IL": 89234, "IN": 76892, "IA": 82345, "KS": 80123,
    "KY": 69874, "LA": 67234, "ME": 79865, "MD": 119876, "MA": 113456, "MI": 78234, "MN": 99234, "MS": 61234,
    "MO": 76543, "MT": 75432, "NE": 83456, "NV": 82156, "NH": 106234, "NJ": 117345, "NM": 67890, "NY": 94567,
    "NC": 76234, "ND": 87654, "OH": 77345, "OK": 65432, "OR": 84567, "PA": 78934, "RI": 89234, "SC": 69876,
    "SD": 73456, "TN": 71234, "TX": 75643, "UT": 89567, "VT": 82345, "VA": 109876, "WA": 98765, "WV": 63456,
    "WI": 78901, "WY": 84321
},
    
    
    // === ENVIRONMENT METRICS ===
    
    // Air Quality Index - Average Annual (EPA 2023)
    airQualityIndex: {
    "AL": 48.2, "AK": 29.7, "AZ": 58.4, "AR": 42.1, "CA": 74.5, "CO": 45.3, "CT": 52.8, "DE": 46.9,
    "FL": 51.7, "GA": 49.6, "HI": 32.1, "ID": 41.8, "IL": 54.2, "IN": 56.7, "IA": 47.3, "KS": 49.1,
    "KY": 51.4, "LA": 53.8, "ME": 38.9, "MD": 49.7, "MA": 48.3, "MI": 47.8, "MN": 43.2, "MS": 46.7,
    "MO": 50.1, "MT": 44.6, "NE": 46.8, "NV": 52.3, "NH": 41.2, "NJ": 55.9, "NM": 47.1, "NY": 51.6,
    "NC": 48.9, "ND": 42.5, "OH": 52.7, "OK": 48.3, "OR": 43.7, "PA": 53.1, "RI": 47.8, "SC": 47.2,
    "SD": 41.9, "TN": 49.8, "TX": 56.2, "UT": 54.1, "VT": 37.4, "VA": 46.8, "WA": 42.3, "WV": 48.9,
    "WI": 45.7, "WY": 43.8
},
    
    // === INFRASTRUCTURE METRICS ===
    
    // Average Internet Speed Mbps (Ookla 2023)
    internetSpeed: {
    "AL": 98.4, "AK": 67.8, "AZ": 115.7, "AR": 89.2, "CA": 128.9, "CO": 119.3, "CT": 134.2, "DE": 118.5,
    "FL": 109.8, "GA": 107.4, "HI": 87.1, "ID": 95.3, "IL": 116.8, "IN": 102.1, "IA": 91.7, "KS": 96.8,
    "KY": 89.4, "LA": 93.7, "ME": 88.9, "MD": 125.3, "MA": 141.7, "MI": 108.2, "MN": 112.6, "MS": 83.1,
    "MO": 104.7, "MT": 78.4, "NE": 98.9, "NV": 111.4, "NH": 126.8, "NJ": 132.6, "NM": 86.7, "NY": 129.4,
    "NC": 113.8, "ND": 87.3, "OH": 109.7, "OK": 92.1, "OR": 117.2, "PA": 114.3, "RI": 128.7, "SC": 101.4,
    "SD": 91.2, "TN": 106.2, "TX": 118.9, "UT": 121.4, "VT": 94.7, "VA": 122.8, "WA": 124.7, "WV": 76.2,
    "WI": 103.8, "WY": 81.7
}
};

export default REAL_STATE_DATA;
